import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";
import BreadcrumbCompany from "../BreadcrumbCompany";
import ProductList from "components/ProductList";
import LogoDiscountPromo from "./DiscountPromo/LogoDiscountPromo";


const WebshopProductList: React.FC = () => {
    return <>
        <BreadcrumbCompany />
        <LogoDiscountPromo/>
        <ProductList displayExtra={true} />
    </>
}

export default WebshopProductList;